import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GraphQLHelper {
    public toGraphQL(source: any): string {
        if (!source) {
            return '{}';
        }

        //create an array that will later be joined into a string.
        const segments = [];
        const type = typeof (source);

        if (Array.isArray(source)) { // array
            for (const key in source) {
                const value = source[key];
                if (value) {
                    segments.push(this.toGraphQL(value));
                }
            }
            return '[' + segments.join(',') + ']';
        } else if (type == 'object') { // object
            for (const key in source) {
                if (source.hasOwnProperty(key)) {
                    segments.push(`${key}:${this.toGraphQL(source[key])}`);
                }
            };
            return `{${segments.join(',')}}`;
        } else if (type === 'boolean' || type == 'number') {
            segments.push(source.toString());
        } else if (type == 'string') {
            segments.push(`"${source}"`);
        }

        return segments.join(',');
    }
}
